module.exports = __webpack_public_path__ + "static/media/live-capital.87ff8813.png";